// src/components/Header.js
import { NavLink } from 'react-router-dom';
import './Header.css';
import { Navbar, Nav, Container } from 'react-bootstrap';

const Header = () => {

  return (
    <>
    <header className="py-4 d-flex flex-column align-items-center text-center bg-ash">
        <img src="/asset/img/logo/kyauLogo.png"  alt="Kyau Logo" className="responsive-img"/>
        <h1 className="fs-2 fw-bold text-tomato">Online Admission System</h1>
        <h4 className=" text-dark-green fw-bold custom-font-maindra-gd">Khwaja Yunus Ali University</h4>
    </header>

    <Navbar className="bg-success navbar" variant='dark' expand="lg">
      <Container>
        <Navbar.Toggle aria-controls="navbar-nav" className="ms-auto" />  {/* Right align toggle button */}
        <Navbar.Collapse id="navbar-nav">
          <Nav className="mx-auto">  {/* Center the nav items */}
            <Nav.Link as={NavLink} to="/" className="nav-link">HOME</Nav.Link>
            <Nav.Link as={NavLink} to="/admit-card" className="nav-link">ADMIT-CARD</Nav.Link>
            <Nav.Link as={NavLink} to="/admission-process" className="nav-link">ADMISSION-PROCESS</Nav.Link>
            <Nav.Link as={NavLink} to="/contact" className="nav-link">CONTACT</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default Header;
